/**
 * How a contact is named where only a short label fits (a chip, a Remove button, a confirm prompt): the
 * first and last name, else the row's own `full_name` (what a card preview carries), else the email, else
 * "Unnamed contact". One helper so a contact reads the same on the deal form and on Deal Detail (#906).
 */
export const contactName = (contact) => [contact?.first_name, contact?.last_name].filter(Boolean).join(' ')
    || contact?.full_name || contact?.email || 'Unnamed contact';

export default contactName;
